import { useContext } from "react";

import { ExpeditionTabContextV2 } from "./ExpeditionTabV2.context";

export const useExpeditionTabContextV2 = () => {
  const ctx = useContext(ExpeditionTabContextV2);
  if (!ctx) {
    throw new Error("useExpeditionTabContextV2 must be used within an ExpeditionTabProviderV2");
  }
  return ctx;
};
